export const basePhotoUrl = 'https://yourdesq.com/images/og-image-v2.jpg';
